import React from "react";
import InfoDashboard from "./infoDashboard";
import TitleWelcome from "./titleWelcome";
import "./host.css";
import { useContext } from "react";
import { Navigate } from "react-router-dom";
import AuthContext from "context/AuthContext";
import StoreDashboard from "../store/StoreDashboard";
import HomePageHost from "./Dashboard/HomePageHost";
import AdminHomepage from "../PureBrand/HomePage/AdminHomepage";
import PurebrandLoader from "components/Loader/PurebrandLoader";
import useCan from "hooks/useCan";
import { CAPABILITIES } from "utils/capabilities";
import { ROLES } from "utils/constants";
import { ROUTES, landingPathFor } from "utils/routes";

const Welcome = () => {
  const { user, userProfile, isEmailVerified, emailVerificationLoading, profileLoading } = useContext(AuthContext);
  const { can, isResolved } = useCan();

  if (profileLoading || emailVerificationLoading || !userProfile) {
    return <PurebrandLoader />;
  }

  const getHostHome = () => {
    if (!isEmailVerified) {
      return <></>
    }
    return <HomePageHost />
  }

  if (user.role === ROLES.HOST.role) {
    return (
      <>
        {!userProfile?.complete_profile ? (
          <>
            <TitleWelcome />
            <InfoDashboard />
          </>
        ) : (
          <>
            {
              getHostHome()
            }
          </>
        )}
      </>
    );
  }

  if (user.role === ROLES.PUREBRAND_ADMIN.role) {
    return (
      <>
        {!userProfile?.complete_profile ? (
          <>
            <TitleWelcome />
            {/* <AdminHomepage /> */}
          </>
        ) : (
          <>
            <AdminHomepage />
          </>
        )}
      </>
    );
  }

  // Store-side roles. Wait for capabilities before deciding, so a cached
  // session is never bounced off a dashboard it is allowed to see.
  if (!isResolved) {
    return <PurebrandLoader />;
  }

  if (can(CAPABILITIES.DASHBOARD_VIEW)) {
    return (
      <>
        {!userProfile?.complete_profile ? (
          <>
            <TitleWelcome />
            {/* <StoreDashboard /> */}
          </>
        ) : (
          <>
            <StoreDashboard />
          </>
        )}
      </>
    );
  }

  // A narrow role (e.g. Accountant) has no dashboard: send them to the first
  // page of their menu instead of rendering a blank home.
  const landing = landingPathFor(can);
  if (landing !== ROUTES.WELCOME) {
    return <Navigate to={landing} replace />;
  }

  return (
    <>
      <TitleWelcome />
    </>
  );
};

export default Welcome;
